import { Card, Col, Row } from "react-bootstrap";
import styles from '../../../../styles/incidents.module.css';
import { useMemo } from "react";
import { _convertDate } from "../../../../utilities/date-converter";

const IncidentSidePanel = ({data,defintions}) => {

    const result = useMemo(() => {
        const selectedUserText = data.staffAssignment !== null ? defintions.usermasterlist.find(item => item.id === data.staffAssignment)?.name : "N/A";
        const selectedFollowupType = data.followupType !== null ? defintions.followuptype.find(item => item.id === data.followupType)?.name : "N/A";
        const areasToCheck = data.areasToCheck.map((item) => {
            return{
                name: item.areaToCheck !== null ? defintions.areastocheck.find(atc => atc.id === item.areaToCheck)?.name : 'N/A',
                comments: item.comments !== null ? item.comments : 'N/A'
            }
        }).sort((a,b) => a.name.localeCompare(b.name));
        const incidentResponseDueDate = data.incidentResponseDueData !== null ? _convertDate(data.incidentResponseDueDate,true) : 'N/A';
        const incidentResponseComments = data.incidentResponseComments !== null ? data.incidentResponseComments : 'N/A';

        const fieldStaffResponseDate = data.fieldStaffResponseDate !== null ? _convertDate(data.fieldStaffResponseDate,true) : 'N/A';
        const fieldStaffResponseComments = data.fieldStaffResponseComments !== null ? data.fieldStaffResponseComments : 'N/A';

        return{
            selectedUserText,
            selectedFollowupType,
            areasToCheck,
            incidentResponseDueDate,
            incidentResponseComments,
            fieldStaffResponseDate,
            fieldStaffResponseComments
        }
    },[data])

    return(
        <Card>
            <Card.Header>
                <h5>Followup Information</h5>
            </Card.Header>
            <Card.Body>
                <div className={styles.columnSidePanel}>
                    <div>
                        <h6 className="fw-bold mb-0">Assigned Staff</h6>
                        <p className="mb-0">
                            {result.selectedUserText}
                        </p>
                    </div>
                    <div>
                        <h6 className="fw-bold mb-0">Followup Type</h6>
                        <p className="mb-0">
                            {result.selectedFollowupType}
                        </p>
                    </div>
                    <div>
                        <h6 className="fw-bold mb-0">Specific Areas To Check</h6>
                            <ul>
                                {
                                    result.areasToCheck.map((item,index) => (
                                        <li key={index}>
                                            <div>
                                                <strong>{item.name}</strong>
                                                <p className="mb-0">{item.comments}</p>
                                            </div>
                                        </li>
                                    ))
                                }
                            </ul>
                    </div>
                    <div>
                        <h6 className="fw-bold mb-0">Incident Response Due Date</h6>
                        <p className="mb-0">
                            {result.incidentResponseDueDate}
                        </p>
                        <h6 className="fw-bold mb-0">Incident Response Comments</h6>
                        <p className="mb-0">
                            {result.incidentResponseComments}
                        </p>
                    </div>
                    <div>
                        <h6 className="fw-bold mb-0">Field Staff Response Date</h6>
                        <p className="mb-0">
                            {result.fieldStaffResponseDate}
                        </p>
                        <h6 className="fw-bold mb-0">Field Staff Response Comments</h6>
                        <p className="mb-0">
                            {result.fieldStaffResponseComments}
                        </p>
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default IncidentSidePanel;